import React from 'react';
import { Alert, AlertTitle, Button, Collapse, Box } from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

interface NotificationSuggestionProps {
  show: boolean;
  onDismiss: () => void;
  onSaveFilter: () => void;
}

function NotificationSuggestion({ show, onDismiss, onSaveFilter }: NotificationSuggestionProps) {
  return (
    <Collapse in={show} unmountOnExit>
      <Box sx={{ mx: 1, my: 1, width: 'auto' }}>
        <Alert
          severity="info"
          icon={<NotificationsActiveIcon />}
          onClose={onDismiss}
          sx={{
            '& .MuiAlert-message': { width: '100%', overflow: 'hidden' },
            '& .MuiAlert-action': { alignItems: 'flex-start', pt: 0, mr: 0 },
          }}
        >
          <AlertTitle sx={{ fontSize: '0.9rem', mb: 0.5 }}>Restez informé !</AlertTitle>
          <Box sx={{ fontSize: '0.8rem', lineHeight: 1.3, mb: 1 }}>
            Sauvegardez vos filtres pour être notifié des nouveaux acteurs et événements.
          </Box>
          <Button
            color="primary"
            variant="contained"
            size="small"
            fullWidth
            onClick={onSaveFilter}
            startIcon={<NotificationsActiveIcon fontSize="small" />}
            sx={{ textTransform: 'none', fontSize: '0.8rem' }}
          >
            Sauvegarder
          </Button>
        </Alert>
      </Box>
    </Collapse>
  );
}

export default NotificationSuggestion;
